<template>
  <div id="evaluate">
    <div class="header2">
      <div class="header2Wrap">
        <div class="header2L">
          <img src="@/assets/list/logo.png" alt />
        </div>
        <p class="button1">
          <i class="fa fa-reply" aria-hidden="true"></i>
          <span @click="goShoppingMall()">返回商城</span>
        </p>
      </div>
    </div>
    <!-- 主体 -->
    <div class="main">
      <h3>商品评价</h3>
      <div class="content">
        <div class="wrap" v-for="(item,index) in ddmxList" :key="index">
          <div class="list1">
            <div class="list1-img">
              <img :src="$store.state.imgUrl+item.atPhotoUrl" alt />
            </div>
            <p class="list1-p">{{item.atSpmc}}</p>
            <div class="list1-rideo">
              <el-checkbox v-model="submitList[index].atNmpl">匿名评价</el-checkbox>
            </div>
          </div>
          <div class="tables">
            <el-table
              id="tables"
              :data="spglList"
              style="width: 100%;"
              :cell-style="rowClass"
              :header-cell-style="headClass"
              v-if="spglList.length>0"
            >
              <el-table-column prop="ypglName" label="药品名称" width="180"></el-table-column>
              <el-table-column prop="atSpsl" label="商品数量" width="180"></el-table-column>
              <el-table-column label="原价单价">
                <template slot-scope="scope">
                  <span>￥{{scope.row.atYpdj}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="atBzgg" label="包装规格"></el-table-column>
              <el-table-column label="总价">
                <template slot-scope="scope">
                  <span>￥{{scope.row.ypzj}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="list2">
            <p>宝贝与描述相符打分:</p>
            <div class="block">
              <el-rate v-model="submitList[index].atPjxj"></el-rate>
            </div>
          </div>
          <el-input type="textarea" v-model="submitList[index].atPjnr" class="textar"></el-input>
        </div>

        <p class="btnss">
          <span @click="submit()">发表评论</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Shopping",
  data() {
    return {
      userId: "",
      checked: true,
      value1: 0,
      desc: "",
      id: "", //订单明细id
      spSpgl: "", //商品id
      dataList: [],
      ddmxList: [],
      submitList: [], //用于提交订单
      spglList: [] //如果是处方药，详情
    };
  },
  components: {},
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = this.userInfo.id;
    }
    this.id = this.$route.query.id;
    this.spSpgl = this.$route.query.spSpgl;
    this.getData();
  },
  methods: {
    getData() {
      var params = {};
      params.id = this.$route.query.id;
      params.createBy =this.userId;
      let url = "/ddgl/getAppIndexListDetailV2";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          console.log(res.data.data);
          this.dataList = res.data.data;
          this.ddmxList = res.data.data.ddmxList;//商品订单详情
          if (res.data.data.spglList && res.data.data.spglList.length > 0) {
            this.spglList = res.data.data.spglList;
          }
          if (res.data.data.spglList && res.data.data.spglList.length > 0) {
            //当为处方时
             for (var i = 0; i < this.ddmxList.length; i++) {
                this.submitList.push({
                  atNmpl: false,
                  spDdgl: this.ddmxList[i].id,
                  userId: this.userId,
                  atPjxj: 5,
                  atPjnr: ""
                });
            }
          } else {
            for (var i = 0; i < this.ddmxList.length; i++) {
              this.submitList.push({
                //当为商品时
                atNmpl: false,
                spDdmx: this.ddmxList[i].id,
                userId: this.userId,
                atPjxj: 5,
                atPjnr: ""
              });
            }
          }
        }
      });
    },
    submit() {
      //  var params = {};
      //  var arr = [];
      //  if(this.checked){
      //     params.atNmpl = 0;//匿名
      //  }else{
      //     params.atNmpl = 1;//非匿名
      //  }
      //  if(this.value1 == 0){
      //      this.$message({
      //           message: '请选择星级',
      //           type: 'warning'
      //         });
      //         return false;
      //  }
      //   params.spDdmx =  this.ddmxList[0].id;//订单明细id
      //   params.userId = this.userId;
      //    params.atPjxj = this.value1;
      //    params.atPjnr = this.desc;
      //    arr.push(params);
      for (var i = 0; i < this.submitList.length; i++) {
        if (this.submitList[i].atNmpl) {
          this.submitList[i].atNmpl = 0; //匿名
        } else {
          this.submitList[i].atNmpl = 1; //非匿名
        }
        if (this.submitList[i].atPjxj == 0) {
          this.$message({
            message: "请选择星级",
            type: "warning"
          });
          return false;
        }
        if (this.submitList[i].atPjnr == "") {
          this.$message({
            message: "请输入评价内容",
            type: "warning"
          });
          return false;
        }
      }
      console.log(this.submitList);
      var submitLists = null;
      if (this.spglList.length > 0) {
        var url = "/plgl/cfSave";
        submitLists = this.submitList[0];
      } else {
        var url = "/plgl/save";
        submitLists = this.submitList;
      }

      this.$http.post(url, submitLists).then(res => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "提交成功!"
          });

          this.$router.go(-1);
        } else if (res.data.code == 20001) {
          this.$message({
            message: res.data.msg,
            type: "warning"
          });
        }
      });
    },
    goShoppingMall() {
      //返回商城
      this.$router.push({ path: "/commodity" });
    },
    // 表头样式设置
    headClass() {
      return "text-align: center;background:#eef1f6;";
    },
    // 表格样式设置
    rowClass() {
      return "text-align: center;";
    }
  }
};
</script>
<style scoped>
.main {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}
.header2 {
  width: 100%;
  height: 94px;
  background-color: #f64420;
}
.header2Wrap {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  height: 100%;
  margin: 0px auto;
}
.header2L {
  float: left;
  width: 280px;
  height: 80%;
  margin-top: 10px;
}
.header2L img {
  width: 100%;
  height: 100%;
}
.button1 {
  float: right;
  width: 107px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 16px;
  border: solid 1px #ffffff;
  cursor: pointer;
  margin-top: 30px;
  opacity: 0.8;
}
.content {
  width: 100%;
}
.content::after {
  content: "";
  height: 0;
  clear: both;
  overflow: hidden;
  display: block;
  visibility: hidden;
}
.tables {
  width: 100%;
  margin-top: 20px;
}
.list1 {
  width: 100%;
  height: 93px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 10px;
}
.list1-img {
  float: left;
  width: 100px;
  height: 72px;
  overflow: hidden;
}
.list1-img img {
  display: block;
  width: 100%;
  min-height: 100%;
}
.list1-p {
  float: left;
  width: 60%;
  height: 100%;
  line-height: 50px;
  font-size: 18px;
  letter-spacing: 1px;
  color: #333333;
  vertical-align: middle;
  margin-left: 10px;
}
.list1-rideo {
  float: right;
  margin-top: 20px;
}
.list2 {
  width: 100%;
  height: 52px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 10px;
}
.list2 p {
  height: 32px;
  width: 200px;
  line-height: 32px;
  float: left;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #333333;
}
.list2 .block {
  float: right;
}
.textar {
  display: block;
  width: 100%;
  height: 170px;
  background-color: #ffffff;
  border: solid 1px #dddddd;
  margin-top: 20px;
  font-size: 16px;
}
.btnss {
  width: 100%;
  height: 35px;
  margin-top: 30px;
  margin-bottom: 60px;
}
.btnss span {
  display: block;
  height: 30px;
  line-height: 30px;
  width: 170px;
  background-color: #f64420;
  font-size: 18px;
  text-align: center;
  letter-spacing: 2px;
  color: #ffffff;
  margin: 0 auto;
  cursor: pointer;
}
</style>
<style >
#evaluate .el-textarea__inner {
  display: block;
  height: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/evaluate.vue